import React from 'react'
import { FRAME_TITLES } from './constants'
import {
  StoryboardGrid,
  StoryboardPanelWrapper,
  StoryboardPanel,
  StoryboardPanelPlaceholder,
  StoryboardFrameTitle,
  StoryboardCaption,
} from '../styles/StoryboardNodeStyles'

interface StoryboardPanelGridProps {
  storyboardUrls: string[]
  frameCaptions: string[] | undefined
  panelErrors: boolean[]
  onPanelError: (index: number) => void
}

export const StoryboardPanelGrid = React.memo(
  ({ storyboardUrls, frameCaptions, panelErrors, onPanelError }: StoryboardPanelGridProps) => (
    <StoryboardGrid>
      {[0, 1, 2, 3].map((index) => (
        <StoryboardPanelWrapper key={index}>
          {storyboardUrls[index] && !panelErrors[index] ? (
            <StoryboardPanel
              src={storyboardUrls[index]}
              alt={`Panel ${index + 1}`}
              loading="lazy"
              onError={() => onPanelError(index)}
            />
          ) : (
            <StoryboardPanelPlaceholder>{index + 1}</StoryboardPanelPlaceholder>
          )}
          <StoryboardFrameTitle>{FRAME_TITLES[index]}</StoryboardFrameTitle>
          {frameCaptions?.[index] && <StoryboardCaption>{frameCaptions[index]}</StoryboardCaption>}
        </StoryboardPanelWrapper>
      ))}
    </StoryboardGrid>
  )
)

StoryboardPanelGrid.displayName = 'StoryboardPanelGrid'
